<template>
  <div class="login-container"
    :style="{ 'background-image': 'url(' + require('../../../static/images/login_bg.jpg') + ')' }">
    <div class="formContainer">
      <div class="formHeader">
        <img class="logo" :src="require('../../../static/images/logo.png')" alt="">
      </div>
      <el-form ref="loginForm" :model="form" :rules="rules" v-loading="isLoading">
        <el-form-item prop="userName">
          <el-input v-model="form.userName" auto-complete="off" placeholder="手机号" prefix-icon="fa fa-user"
            class="ox-login__input"></el-input>
        </el-form-item>
        <el-form-item prop="passWord">
          <el-input v-model="form.passWord" placeholder="密码" prefix-icon="fa fa-unlock-alt" class="ox-login__input"
            type="password"></el-input>
        </el-form-item>
        <el-form-item prop="captcha">
          <el-input v-model="form.captcha" placeholder="不区分大小写" prefix-icon="fa fa-unlock-alt" class="captchaInp"
            @keyup.enter.native="onSubmit">
          </el-input>
          <span v-html="svgHtml" @click="getCaptcha" class="captchaImg"></span>
        </el-form-item>
        <el-form-item>
          <el-checkbox label="七天免登录，公共场合禁止启用" v-model="landFlag"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" class="loginBtn">登录</el-button>
        </el-form-item>
      </el-form>

      <el-dialog title="请选择需要登录的角色" :visible.sync="dialogVisible" :show-close="false" width="30%">
        <el-select v-model="choosedRole" placeholder="请选择">
          <el-option v-for="item in roles" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="chooseOk">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import config from "@/config/config";
import { validatePhoneNumber } from "@/utils";
import axios from "axios";
export default {
  data() {
    let validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (value != "admin" && !validatePhoneNumber(this.form.userName)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    return {
      svgHtml: "",
      landFlag: true,
      form: {
        userName: "",
        passWord: "",
        captcha: "",
        encryptCaptcha: "",
      },
      dialogVisible: false,
      roles: [],
      choosedRole: null,
      user: null,
      rules: {
        userName: [
          {
            validator: validatePhone,
            type: "number",
          },
        ],
        passWord: [
          {
            required: true,
            message: "请输入密码",
          },
        ],
        captcha: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      isLoading: false,
    };
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    // api获取验证码
    getCaptcha() {
      this.encryptCaptcha = "";
      axios
        .get("auth/employee/captcha")
        .then((response) => {
          this.svgHtml = response.data.data.data;
          this.encryptCaptcha = response.data.data.text;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 发送登录信息到后台验证
    checkAction(callback) {
      // 加密密码
      var NodeRSA = require("node-rsa");
      let pubKey = new NodeRSA(config.pubKey);
      let encryptPassword = pubKey.encrypt(this.form.passWord, "base64");
      let params = {
        system: config.systemAuth,
        phone: this.form.userName,
        password: encryptPassword,
        captcha: this.form.captcha,
        encryptCaptcha: this.encryptCaptcha,
      };
      axios
        .get("auth/employee/login", { params })
        .then((response) => {
          this.isLoading = false;
          callback(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 提交
    onSubmit() {
      this.roles = [];
      this.choosedRole = null;
      this.user = null;
      this.$refs.loginForm.validate((result) => {
        if (result) {
          this.isLoading = true;
          this.checkAction((response) => {
            this.isLoading = false;
            if (response.data.success === true) {
              let roles = response.data.user.roles.map((item) => item.name);

              let user = {
                nameEN: response.data.user.nameEN,
                nameZH: response.data.user.nameZH,
                openid: response.data.user.openid,
                privileges: response.data.user.privileges,
                token: response.data.token,
                worksite: response.data.user.worksite["_id"],
                worksiteName:
                  response.data.user.worksite.shortName +
                  "" +
                  response.data.user.worksite.schoolCampus,
                printer150Ip: response.data.user.worksite.printer150Ip,
                printer150Port: response.data.user.worksite.printer150Port,
                printer180Ip: response.data.user.worksite.printer180Ip,
                printer180Port: response.data.user.worksite.printer180Port,
                roles: roles,
                sideRight: response.data.user.sideRight,
                employeeCode: response.data.user.employeeCode,
                exWorksites: response.data.user.exWorksites,
                wmBoxsites: response.data.user.wmBoxsites
              };

              this.user = user;
              if (roles.length > 1) {
                this.roles = roles;
                this.dialogVisible = true;
              } else {
                this.gotoDesktop();
              }
            } else {
              this.svgHtml = response.data.captcha.data;
              this.encryptCaptcha = response.data.captcha.text;
              this.$message({
                message: response.data.message,
                type: "warning",
              });
            }
          });
        }
      });
    },
    chooseOk() {
      this.dialogVisible = false;
      this.user.roles = [this.choosedRole];
      this.gotoDesktop();
    },
    gotoDesktop() {
      if (this.landFlag) {
        let date = new Date();
        date.setDate(date.getDate() + 7);
        this.$cookies.set("user", JSON.stringify(this.user), {
          expires: date.toGMTString(),
        });
      } else {
        this.$cookies.set("user", JSON.stringify(this.user));
      }
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  height: 100vh;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.formContainer {
  width: 360px;
  margin: auto;
  padding: 3rem 2rem;
  background-color: #fff;
}

.formHeader {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
}

.logo {
  width: 100px;
}

.captchaInp {
  width: 60%;
  display: inline-block;
}

.captchaImg {
  width: 40%;
  height: 40px;
  float: right;
  position: relative;
  top: -0.5rem;
}

.loginBtn {
  float: right;
}

.el-form-item:last-child {
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue